import App from './App.svelte';

const app = new App({
	target: document.getElementById('recipe-category'),
	props: {
		thisCategory: window.thisCategory,
		firstSet: window.firstSet,
		cuisines: window.cuisine,
		keyIngredients: window.keyIngredients,
		occasions: window.occasion,
		dietary: window.dietary,
		flavors: window.flavors,
		cookingMethods: window.cooking_method,
		bakingTypes: window.bakingType
	}
});

export default app;
